export type ReflectionType = "New" | "Answered" | "Expired";

export default function getReflectionTypeIcon(type: ReflectionType) {
  switch (type) {
    case "New":
      return "notifications";
    case "Answered":
      return "check-circle";
    case "Expired":
      return "timer-off";
  }
}
